import React from 'react';
import FieldLabel from './field-label';
import FieldHelpText from './field-help-text';
import FieldMandatory from './field-mandatory';
import FieldWidth from './field-width';
import ConditionId from './condition-id';

export default class DateField extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      conditions: props.conditions,
      model: props.model,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return prevState.conditions === nextProps.conditions ?
      null :
      {conditions: nextProps.conditions};
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = { ...prevState.model };
        model[fieldName] = value;
        return { model };
      },
      () => this.props.onChange(this.state.model)
    );
  }

  render() {
    return <>
      <FieldLabel value={this.state.model.label} onChange={v => this.updateModel('label', v)} />
      <FieldHelpText value={this.state.model.helpText} onChange={v => this.updateModel('helpText', v)} />
      <FieldMandatory id={this.props.id}
                      value={this.state.model.mandatory}
                      onChange={v => this.updateModel('mandatory', v)}
                      conditionallyDisplayed={!!this.state.model.conditionId}/>
      <FieldWidth value={this.state.model.widthInPercent} onChange={v => this.updateModel('widthInPercent', v)} />
      <DateFormat id={this.props.id} value={this.state.model.dateFormat} onChange={v => this.updateModel('dateFormat', v)} />
      <ConditionId id={this.props.id}
                   conditions={this.state.conditions}
                   value={this.state.model.conditionId}
                   onChange={v => this.updateModel('conditionId', v)}/>
    </>
  }

}

class DateFormat extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  updateValue(value) {
    this.setState(
      { value },
      () => this.props.onChange(this.state.value)
    );
  }

  render() {
    return <div className="mb-3">
      <label htmlFor={this.props.id + 'DateFormat'}
             className="form-label">
        Date format
      </label>
      <select id={this.props.id + 'DateFormat'}
              className="form-select"
              value={this.state.value || ''}
              onChange={e => this.updateValue(e.target.value)}>
        <option value={'yyyy-MM-dd'}>yyyy-mm-dd</option>
        <option value={'yyyy/MM/dd'}>yyyy/mm/dd</option>
        <option value={'MM-dd-yyyy'}>mm-dd-yyyy</option>
        <option value={'MM/dd/yyyy'}>mm/dd/yyyy</option>
        <option value={'dd-MM-yyyy'}>dd-mm-yyyy</option>
        <option value={'dd/MM/yyyy'}>dd/mm/yyyy</option>
      </select>
      <div className="form-text">
        Used for notifications and integrations only, <i>not</i> as an input format when the form is being filled out.
      </div>
    </div>
  }

}
